module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buubletextafteraction":"Please face towards the camera, tap on the microphone button, and ask a court or county related question."},"es":{"buubletextafteraction":"El reconocimiento de voz está desactivado para el idioma español."}}')
  delete Component.options._Ctor
}
